import React from 'react';
import LeftNav from './LeftNav';

const Page = props => (
  <div className="layout">
    <section id="qlik-left-nav">
      <div className="container-fluid">
        <div className="row">
          <LeftNav {...props} />
        </div>
        <div className="row border-top-gray pt15">
          <div className="col-md-12 text-right">
            <a href="https://www.qlik.com"><img src="assets/powered-by-Qlik-Horizontal.png" alt="PoweredByQlik" className="logo" /></a>
          </div>
        </div>
      </div>
    </section>
    <section id="qlik-main">
      <div id="data-overview" />
    </section>
  </div>
);

export default Page;
